export default (el, res = true) => {
  if (res) {
    let wordArray;
    // eslint-disable-next-line
    window.requestAnimationFrame(() => {
      wordArray = el.innerHTML.split(/\s/).filter(e => e != "");
      if (wordArray.lenght === 1) {
        return;
      }
      while (el.scrollHeight > el["offsetHeight"] && wordArray.length > 0) {
        wordArray.pop();
        if (wordArray[wordArray.length - 1].indexOf(",") !== -1) {
          wordArray.pop();
        }
        if (wordArray[wordArray.length - 1].match(/, ?$/)) {
          wordArray[wordArray.length - 1] = wordArray[
            wordArray.length - 1
          ].replace(/, ?$/, "");
        }
        el.innerHTML = wordArray.join(" ").concat("...");
        el["dataset"].cropped = true;
      }
    });
  }
  return true;
};
